/**
 * hasClass, takes two params: element and classname
 */

export default function hasClass (el, cls) {
    return el.className && new RegExp(`(\\s|^)${cls}(\\s|$)`).test(el.className)
}
